import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

let refreshing = null;

api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const original = error.config || {};
    const status = error.response?.status;
    const detail = error.response?.data?.detail;

    if (status === 402 && detail?.error === 'insufficient_credits') {
      window.dispatchEvent(new CustomEvent('photoplan:insufficient-credits', { detail }));
      return Promise.reject(error);
    }

    if (status === 403 && detail?.error === 'account_frozen') {
      window.dispatchEvent(new CustomEvent('photoplan:account-frozen', { detail }));
      return Promise.reject(error);
    }

    if (status === 401 && !original._retry) {
      const refresh_token = localStorage.getItem('refresh_token');
      if (!refresh_token) {
        window.dispatchEvent(new CustomEvent('photoplan:logout'));
        return Promise.reject(error);
      }
      original._retry = true;
      try {
        if (!refreshing) {
          refreshing = axios.post(`${API}/auth/refresh`, { refresh_token });
        }
        const r = await refreshing;
        refreshing = null;
        localStorage.setItem('token', r.data.access_token);
        if (r.data.refresh_token) localStorage.setItem('refresh_token', r.data.refresh_token);
        original.headers.Authorization = `Bearer ${r.data.access_token}`;
        return api(original);
      } catch (e) {
        refreshing = null;
        localStorage.removeItem('token');
        localStorage.removeItem('refresh_token');
        window.dispatchEvent(new CustomEvent('photoplan:logout'));
        return Promise.reject(e);
      }
    }
    return Promise.reject(error);
  }
);

export default api;
